var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { cloneDeep } from 'lodash';
import { Form } from 'packages/form/entities/Form';
import { EntityBuilder, Type } from '@decahedron/entity';
import { Question } from 'packages/form/entities/question/Question';
import { Result } from 'packages/form/entities/Result';
import moment from 'moment';
var Response = /** @class */ (function (_super) {
    __extends(Response, _super);
    function Response() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formId = null;
        _this.additionalQuestions = [];
        _this.preview = false;
        _this.dataProcessingConsent = false;
        _this.result = null;
        _this.jobId = null;
        _this.job = null;
        _this.createdAt = null;
        return _this;
    }
    Object.defineProperty(Response.prototype, "id", {
        get: function () {
            return this.uuid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "formUuid", {
        get: function () {
            return this.formId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Response.prototype, "positionedQuestions", {
        get: function () {
            var questionsWithCorrectPosition = cloneDeep(this.questions);
            return questionsWithCorrectPosition.map(function (q, i) { return EntityBuilder.buildOne(Question, __assign(__assign({}, q.toJson()), { position: i + 1 })); });
        },
        enumerable: false,
        configurable: true
    });
    Response.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        this.createdAt = moment.utc(jsonData.created_at).local();
        return this;
    };
    var _a;
    __decorate([
        Type(Question),
        __metadata("design:type", Array)
    ], Response.prototype, "questions", void 0);
    __decorate([
        Type(Question),
        __metadata("design:type", Array)
    ], Response.prototype, "additionalQuestions", void 0);
    __decorate([
        Type(Result),
        __metadata("design:type", typeof (_a = typeof Result !== "undefined" && Result) === "function" ? _a : Object)
    ], Response.prototype, "result", void 0);
    return Response;
}(Form));
export { Response };
